import React from 'react';
import IGStoryReactionSlideoutBannerNormalSrc from './IGStoryReactionSlideoutBanner_normal.png';
import IGStoryReactionSlideoutBannerWhiteSrc from './IGStoryReactionSlideoutBanner_white.png';

export const IGStoryReactionSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGStoryReactionSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGStoryReactionSlideoutBannerNormalSrc} />
  );
};
